import utils from 'utils';
import config from './fieldConfig'

class ovatBillListCtrl {
  constructor(
    $scope,
    $uibModal,
    logger,
    httpRequest,
    $state,
    sweetalert,
    initSortService,
    globalFn,
    getOvatAmtService,
    resultTipService,
    batchHandle,
    batchFilterService
  ) {
    $scope.dictData = {};
    const types = [
      'inv_type',
      'invoice_nature',
      'ovat_tax_rate',
      'bill_status',
      'approve_status',
      'specific_element',
    ];
    httpRequest.get_dictByTypeArr(types).then((res) => {
      $scope.dictData = res.data.value;
    });
    $scope.active = sessionStorage.billActiveParam
      ? +sessionStorage.billActiveParam
      : 1;
    $scope.dictData2 = {};
    // 处理状态
    $scope.dictData2.bill_status_copy1 = [
      {
        enumName: '待处理',
        enumCode: '0',
      },
      {
        enumName: '已作废',
        enumCode: '4',
      },
    ];
    $scope.dictData2.bill_status_copy2 = [
      {
        enumName: '被拆分',
        enumCode: '1',
      },
      {
        enumName: '被合并',
        enumCode: '2',
      },
      {
        enumName: '其他信息处理',
        enumCode: '3',
      },
    ];
    $scope.dictData2.bill_status_copy3 = $scope.dictData2.bill_status_copy2;
    // 审核状态
    $scope.dictData2.approve_status_copy1 = [
      {
        enumName: '待提交',
        enumCode: '0',
      },
      {
        enumName: '审核不通过',
        enumCode: '2',
      },
      {
        enumName: '被回退',
        enumCode: '4',
      },
    ];
    $scope.dictData2.approve_status_copy2 = [
      {
        enumName: '审核中',
        enumCode: '1',
      },
      {
        enumName: '审核通过',
        enumCode: '3',
      },
    ];

    $scope.billBatchDelOrCancel = function (v) {
      if (!$scope.selectedList.length)
        return logger.logError('请选择至少一条数据再操作！');
      const condition = v ? 'ABOLITION' : 'DELETE';
      const batchWord = v ? '作废' : '删除';
      batchFilterService
        .ovatBatchFilter($scope.selectedList, {
          condition: {
            word: condition,
            val: true,
          },
          text: batchWord,
          isDelete: !v,
          isCancel: v,
        })
        .then((arr) => {
          const batchApi = v ? 'get_batchAbolishBill' : 'get_batchDelBill';

          const idArr = [];
          arr.forEach((item) => {
            idArr.push(item.billId);
          });

          httpRequest[batchApi](idArr).then((res) => {
            logger.logSuccess(`${batchWord}成功`);
            queryOvatBillList();
          });
        });
    };
    $scope.currentOvatAmt = {};
    $scope.$watch('selectedList.length', () => {
      if (!$scope.selectedList.length) {
        $scope.adValoremTotal = $scope.currentOvatAmt.adValoremTotal;
        $scope.invoiceNum = $scope.currentOvatAmt.invoiceNum;
        $scope.totalAmt = $scope.currentOvatAmt.totalAmt;
        $scope.totalTaxamt = $scope.currentOvatAmt.totalTaxamt;
        return;
      }
      const { adValoremTotal, totalAmt, totalTaxamt } = getOvatAmtService(
        $scope.selectedList
      );
      $scope.adValoremTotal = adValoremTotal;
      $scope.invoiceNum = $scope.selectedList.length;
      $scope.totalAmt = totalAmt;
      $scope.totalTaxamt = totalTaxamt;
    });

    function getData() {
      httpRequest.post_billTotal($scope.queryParam).then((res) => {
        $scope.adValoremTotal =
          res.data.value.adValoremTotal.toFixed(2) || '0.00';
        $scope.invoiceNum = res.data.value.billTotal || 0;
        $scope.totalAmt = res.data.value.totalAmt.toFixed(2) || '0.00';
        $scope.totalTaxamt = res.data.value.totalTaxamt.toFixed(2) || '0.00';
        $scope.currentOvatAmt = {
          adValoremTotal: $scope.adValoremTotal,
          invoiceNum: $scope.invoiceNum,
          totalAmt: $scope.totalAmt,
          totalTaxamt: $scope.totalTaxamt,
        };
      });
    }
    const queryOvatBillList = function () {
      const tab = $scope.active;
      $scope.queryParam = sessionStorage.ovatBillParam
        ? JSON.parse(sessionStorage.ovatBillParam)
        : $scope.queryParam;
      $scope.queryParam.param.lifeCycleStatus = $scope.active - 1;

      const openLoading =
        $scope.queryParam.pageSize >= 100
          ? window.layer.msg('正在查询，请耐心等待', {
              time: 0,
              skin: 'layer-loading-self',
              icon: 16,
              shade: 0.5,
            })
          : null;

      httpRequest
        .post_pageBill($scope.queryParam)
        .then((res) => {
          if ($scope.active == tab) {
            $scope.ovatBill.list = res.data.value.list.slice(
              0,
              $scope.queryParam.pageSize
            );
            $scope.totalItems = res.data.value.total;
            $scope.queryParam.pageNum = res.data.value.pageNum;
          }
          $scope.selectedList = [];
        })
        .finally(() => {
          window.layer.close(openLoading);
        });
      getData();
    };
    // ie 滚动条遮盖内容
    $('body').addClass('stick-ie-scrollbar');
    $scope.$on('$stateChangeStart', (e, toState) => {
      $('body').removeClass('stick-ie-scrollbar');
      if (toState.name.indexOf('ovatBill') == -1) {
        sessionStorage.removeItem('billActiveParam');
      }
    });

    // 表头排序
    $scope.orderMap = initSortService('ovatBillOrderMap', true);
    $scope.selectedHandle = function () {
      $scope.queryParam.orderMap = {};
      if ($scope.orderMap.sortKey)
        $scope.queryParam.orderMap[$scope.orderMap.sortKey] =
          $scope.orderMap.sortVal;
      sessionStorage.setItem(
        'ovatBillParam',
        JSON.stringify($scope.queryParam)
      );
      queryOvatBillList();
    };

    /**
     * 红票发票修改开票点
     */
    function changeUkeyId(billId) {
      $uibModal
        .open({
          templateUrl: 'ovatBillChangeUkeyModalCtrl.html',
          controller: 'ovatBillChangeUkeyModalCtrl',
          backdrop: 'static',
          openedClass: 'mod-modal mod-modal-lg',
          resolve: {
            items1() {
              return billId;
            },
          },
        })
        .result.then(
          () => {
            queryOvatBillList();
          },
          () => {}
        );
    }

    $scope.ovatBill = {};
    const aMonth = utils.genPeriodByMonth();
    $scope.queryParam = {
      pageNum: 1,
      pageSize: 10,
      param: {
        applicant: '',
        applyDate: '',
        applyDateMin: aMonth.start,
        applyDateMax: aMonth.end,
        approveStatus: '',
        billCode: '',
        billStatus: '',
        custName: '',
        custCreditCode: '',
        invoiceType: '',
        invoiceNature: '',
        matName: '',
        billDateMin: '',
        billDateMax: '',
        taxRates: '',
        invoiceCode: '',
        invoiceNumber: '',
      },
    };
    $scope.reset = function () {
      $scope.queryParam.param = {
        applicant: '',
        applyDate: '',
        applyDateMin: aMonth.start,
        applyDateMax: aMonth.end,
        approveStatus: '',
        billCode: '',
        billStatus: '',
        custName: '',
        custCreditCode: '',
        invoiceType: '',
        invoiceNature: '',
        matName: '',
        billDateMin: '',
        billDateMax: '',
        taxRates: '',
        invoiceCode: '',
        invoiceNumber: '',
      };
    };
    // $scope.reset()
    // queryOvatBillList()
    // 已选择的数据
    $scope.selectedList = [];

    $scope.customizedConfig = config[$scope.active]
    $scope.tabChange = function tabChange(v) {
      $scope.active = v;
      sessionStorage.setItem('billActiveParam', v);
      $scope.queryParam.orderMap = {};
      $scope.orderMap = {};
      $scope.queryParam.pageNum = 1;
      $scope.reset();
      if (v == 1) {
        $scope.profileType = 133;
        $scope.dictData2.approve_status_copy =
          $scope.dictData2.approve_status_copy1;
        $scope.dictData2.bill_status_copy = $scope.dictData2.bill_status_copy1;
        $scope.customizedConfig = config[$scope.active]
      }
      if (v == 2) {
        $scope.profileType = 134;
        $scope.dictData2.approve_status_copy =
          $scope.dictData2.approve_status_copy2;
        $scope.dictData2.bill_status_copy = $scope.dictData2.bill_status_copy2;
        $scope.customizedConfig = config[$scope.active]
      }
      if (v == 3) {
        $scope.profileType = 135;
        $scope.dictData2.bill_status_copy = $scope.dictData2.bill_status_copy3;
        $scope.customizedConfig = config[$scope.active]
      }
      httpRequest.get_getUserCustomized($scope.profileType).then((res) => {
        if (res.data.value) {
          let data = JSON.parse(res.data.value);
          let orderMap = data.orderMap;
          if (orderMap) {
            $scope.orderMap = orderMap;
            if ($scope.orderMap.sortKey) {
              $scope.queryParam.orderMap[$scope.orderMap.sortKey] =
                $scope.orderMap.sortVal;
            }
          }
        }
        sessionStorage.setItem(
          'ovatBillParam',
          JSON.stringify($scope.queryParam)
        );
        queryOvatBillList();
      });
    };
    $scope.tabChange($scope.active); // 进入或刷新页面初始化

    /**
         * 转换后台返回列表操作权限数据
         * 后台返回数据   [{
            "DETAIL": true
          },
          {
            "EDIT": false
          },]
          转换成{DETAIL:true,EDIT:false}
         * @param  {array} authList  后台返回按钮列表
         * @return {Object}          权限对象
         */
    function parseAuthorityList(authList) {
      const authObj = {};
      authList.forEach((authItem) => {
        Object.assign(authObj, authItem);
      });
      return authObj;
    }
    $scope.tableDropdownConfig = [
      {
        label: '明细',
        handler(item) {
          // $state.go('outputManage.FOManage.ovatBill.checkBillDetail', { billId: item.billId })
          const url = $state.href(
            'outputManage.FOManage.ovatBill.checkBillDetail',
            {
              obj: JSON.stringify({
                billId: item.billId,
              }),
            },
            {
              reload: true,
            }
          );
          window.open(url, '_blank');
        },
        showWhile(item) {
          return item.authMap.DETAIL;
        },
      },
      {
        label: '修改开票点',
        handler(item) {
          changeUkeyId(item.billId);
        },
        showWhile(item, hasPermit) {
          return (
            hasPermit('ovatBill_edit') &&
            item.authMap.EDIT_POINT &&
            $scope.active == 1
          );
        },
      },
      {
        label: '编辑',
        handler(item) {
          $state.go('outputManage.FOManage.ovatBill.detailList', {
            billId: item.billId,
          });
        },
        showWhile(item, hasPermit) {
          return (
            hasPermit('ovatBill_edit') &&
            item.authMap.EDIT &&
            $scope.active == 1
          );
        },
      },
      {
        label: '拆分',
        handler(item) {
          $state.go('outputManage.FOManage.ovatBill.spiltdetailList', {
            billId: item.billId,
          });
        },
        showWhile(item, hasPermit) {
          return (
            hasPermit('ovatBill_split') &&
            item.authMap.SPLIT &&
            item.invoiceType != '12' &&
            $scope.active == 1
          );
        },
      },
      {
        label: '还原',
        handler(item) {
          sweetalert.confirm('操作提醒', '确定需要还原该销售单？').then(
            () => {
              httpRequest.get_reductionBill(item.billId).then(() => {
                queryOvatBillList();
              });
            },
            () => {}
          );
        },
        showWhile(item, hasPermit) {
          return (
            hasPermit('ovatBill_recall') &&
            item.authMap.REDUCTION &&
            $scope.active == 3
          );
        },
      },
      {
        label: '提交',
        handler(item) {
          // if (checkSunInfo(item, '')) {
          $scope.billCommit(item);
          // }
        },
        showWhile(item, hasPermit) {
          return (
            hasPermit('ovatBill_edit') &&
            item.authMap.SUBMIT &&
            $scope.active == 1
          );
        },
      },
      {
        label: '作废',
        handler(item) {
          const msg = '您确定需要作废此销售单？';
          sweetalert.confirm('操作提醒', msg).then(
            () => {
              httpRequest.get_abolishBill(item.billId).then(() => {
                logger.logSuccess('作废成功');
                queryOvatBillList();
              });
            },
            () => {}
          );
        },
        showWhile(item, hasPermit) {
          // 只有蓝票票可以作废
          return (
            hasPermit('ovatBill_cancel') &&
            item.authMap.ABOLITION &&
            $scope.active == 1
          );
        },
      },
      {
        label: '删除',
        handler(item) {
          let msg = '销售单删除后无法恢复，您确定需要删除此销售单？';
          if (item.invoiceNature === '1' && item.invoiceType === '0') {
            msg =
              '您要删除的是专票红票销售单，销售单删除后无法恢复，删除前请确认已在税局撤销红字信息表编号！ 确定，则进行删除流程；取消，则不操作';
          }
          sweetalert.confirm('操作提醒', msg).then(() => {
            httpRequest.get_delBill(item.billId, '销售单删除成功').then(() => {
              queryOvatBillList();
            });
          });
        },
        showWhile(item, hasPermit) {
          return (
            hasPermit('ovatBill_del') &&
            item.authMap.DELETE &&
            $scope.active == 1
          );
        },
      },
    ];
    // 页面跳转
    $scope.pageChanged = function () {
      sessionStorage.setItem(
        'ovatBillParam',
        JSON.stringify({
          orderMap: $scope.queryParam.orderMap,
          pageNum: $scope.queryParam.pageNum,
          pageSize: $scope.queryParam.pageSize,
          param: sessionStorage.ovatBillParam
            ? JSON.parse(sessionStorage.ovatBillParam).param
            : {
                applicant: '',
                applyDate: '',
                applyDateMin: aMonth.start,
                applyDateMax: aMonth.end,
                approveStatus: '',
                billCode: '',
                billStatus: '',
                custName: '',
                custCreditCode: '',
                invoiceType: '',
                invoiceNature: '',
                matName: '',
                billDateMin: '',
                billDateMax: '',
                taxRates: '',
                invoiceCode: '',
                invoiceNumber: '',
              },
        })
      );
      queryOvatBillList();
    };
    /**
     * 合并销售单校验
     * @param  {[type]} selectedList [description]
     * @return {[type]}              [description]
     */
    function checkBillWhenMerge(selectedList) {
      let selected;
      // const firstSelected = selectedList[0]
      let flag = true;
      if (selectedList.length < 2) {
        logger.logError('请至少选择两张或以上销售单进行合并！');
        return false;
      }
      for (let i = 0; i < selectedList.length; i++) {
        selected = selectedList[i];
        if (selected.invoiceNature === '1') {
          logger.logError('只有蓝票销售单才能被合并');
          return false;
        }
        // if (firstSelected.invoiceType !== selected.invoiceType) {
        //     flag = false
        // }
        // if (!flag) {
        //     logger.logError('请选择同一票种的销售单进行合并')
        //     return false
        // }
        if (selected.invoiceType == 12) {
          logger.logError('已选机动车销售单，请重新选择');
          return false;
        }
      }
      return flag;
    }
    //检测所选卷票是否不同规格
    function checkDiffSpec(arr) {
      if (arr[0].invoiceType != 41) return;
      let flag = false;
      const spec = JSON.parse(arr[0].extendInfo).rollticketCode;
      arr.forEach((item) => {
        if (JSON.parse(item.extendInfo).rollticketCode != spec) flag = true;
      });
      return flag;
    }
    // 合并销售单
    $scope.mergeBill = function () {
      // 定义一个选中数组
      const selectList = $scope.selectedList; // 选中销售单列表
      const billIdList = [];
      let isTaxArr = [];
      // TODO 开票合计金额,判断是否大于开票点限额
      if (!checkBillWhenMerge(selectList)) {
        return;
      }
      if (checkDiffSpec(selectList)) {
        return logger.logError(
          '所选择的卷票中存在不同规格，不能进行合并，请选择同一规格的卷票'
        );
      }
      for (var i = 0, len = selectList.length; i < len; i++) {
        let selectedItem = selectList[i];
        billIdList.push(selectedItem.billId);
        let billCodeMsg = '单据' + selectedItem.billCode + '：';
        isTaxArr.push(selectedItem.isTax);
        if (!checkSunInfo(selectedItem, billCodeMsg)) return;
      }
      httpRequest.get_qryAllValidRule().then((res) => {
        $scope.ruleList = res.data.value;
        $scope.item = {
          billIdList,
          flag: 4,
          ruleList: $scope.ruleList,
          isMerge: true,
          diffTax: Array.from(new Set(isTaxArr)).length > 1 ? true : false,
        };
        const modalInstance = $uibModal.open({
          templateUrl: 'ovatBillRuleModalCtrl.html',
          controller: 'splitBillRuleModalCtrl',
          openedClass: 'mod-modal mod-modal-lg',
          backdrop: 'static',
          resolve: {
            items1() {
              return $scope.item;
            },
          },
        });
        modalInstance.result.then(
          () => {
            queryOvatBillList();
          },
          () => {
            // console.log(111)
          }
        );
        // }
      });
    };

    $scope.billCommit = function (item) {
      utils.loading('正在提交');
      const { billId } = item;
      if (item.invoiceType != 12) {
        httpRequest.get_qryAllValidRule().then((res) => {
          $scope.ruleList = res.data.value;
          utils.loaded();
          if ($scope.ruleList.length === 1) {
            httpRequest
              .get_billCommit(billId, '000000', '销售单提交成功')
              .then(() => {
                queryOvatBillList();
              });
          } else {
            $scope.item = {
              flag: 2,
              billId,
              ruleList: $scope.ruleList,
            };
            const modalInstance = $uibModal.open({
              templateUrl: 'ovatBillRuleModalCtrl.html',
              controller: 'splitBillRuleModalCtrl',
              openedClass: 'mod-modal mod-modal-lg',
              backdrop: 'static',
              resolve: {
                items1() {
                  return $scope.item;
                },
              },
            });
            modalInstance.result.then(
              () => {
                queryOvatBillList();
              },
              () => {}
            );
          }
        });
      } else {
        httpRequest
          .get_billCommit(billId, '000000', '销售单提交成功')
          .then(() => {
            queryOvatBillList();
          });
      }
    };

    function commonBatchSubmit(billIdList) {
      batchHandle.open().then((data) => {
        utils.loading('系统正在批量处理中，请耐心等待...');
        if (data.startRow || data.endRow) {
          const subParams = $.extend(
            data,
            {
              billRuleCode: '000000',
            },
            $scope.queryParam
          );
          httpRequest.post_billRangeCommit(subParams).then((res) => {
            submitCallback(res);
          });
        } else {
          httpRequest
            .get_billBatchCommit({
              billIdList: billIdList,
              billRuleCode: '000000',
            })
            .then((res) => {
              submitCallback(res);
            });
        }
      });
    }

    function submitCallback(res) {
      utils.loaded();
      if (res.data.value.error) {
        const params = {
          sourceCount: res.data.value.total,
          errorCount: res.data.value.error,
          list: res.data.value.messageList,
          title: '提交',
        };
        resultTipService.openErrorModal(params, queryOvatBillList);
      } else {
        logger.logSuccess(`提交成功${res.data.value.total}张票据`);
        queryOvatBillList();
      }
    }
    // 销售单批量提交 TODO
    $scope.billBatchCommit = function (bill) {
      const selectList = bill ? [bill] : $scope.selectedList; // 选中销售单列表
      const billIdList = [];
      let allVehicleInv = true;
      if (selectList.length === 0) {
        logger.logError('请选择至少一条数据再操作！');
      } else {
        batchFilterService
          .ovatBatchFilter(selectList, {
            condition: {
              word: 'SUBMIT',
              val: true,
            },
            text: '提交',
            isSubmit: true,
          })
          .then((arr) => {
            for (var i = 0, len = arr.length; i < len; i++) {
              let selected = arr[i];
              billIdList.push(selected.billId);
              if (allVehicleInv) {
                allVehicleInv = selected.invoiceType == 12;
              }
              // let billCodeMsg = '单据' + selected.billCode + '：'
              // if (!checkSunInfo(selected, billCodeMsg)) return
            }
            // 如所选发票全部为机动车发票则免拆合规则弹框
            if (!allVehicleInv) {
              httpRequest.get_qryAllValidRule().then((res) => {
                $scope.ruleList = res.data.value;
                if ($scope.ruleList.length === 1) {
                  commonBatchSubmit(billIdList);
                } else {
                  $scope.item = {
                    flag: 3,
                    billIdList,
                    ruleList: $scope.ruleList,
                  };
                  const modalInstance = $uibModal.open({
                    templateUrl: 'ovatBillRuleModalCtrl.html',
                    controller: 'splitBillRuleModalCtrl',
                    openedClass: 'mod-modal mod-modal-lg',
                    backdrop: 'static',
                    resolve: {
                      items1() {
                        return $scope.item;
                      },
                    },
                  });
                  modalInstance.result.then(
                    (data) => {
                      if (data) {
                        const subParams = $.extend(data, $scope.queryParam);
                        httpRequest
                          .post_billRangeCommit(subParams)
                          .then((res) => {
                            submitCallback(res);
                          });
                      } else {
                        queryOvatBillList();
                      }
                    },
                    () => {}
                  );
                }
              });
            } else {
              commonBatchSubmit(billIdList);
            }
          });
      }
    };
    // 下载导入模板
    $scope.downOvatBill = function () {
      window.open(
        `${
          host.etcloudOvat
        }dlTaskService/export_OVAT_BILL?accessToken=${localStorage.getItem(
          'id_token'
        )}`
      );
    };

    // 状态按钮滑过
    $scope.dropdown_rowhover_state = function (row, flag) {
      row.dropdowstatenhover = flag;
    };

    // 搜索
    $scope.search = function () {
      sessionStorage.setItem(
        'ovatBillParam',
        JSON.stringify($scope.queryParam)
      );
      queryOvatBillList();
    };

    $scope.isCollapsed = false;

    // modal

    $scope.open = function (v) {
      if (!JSON.parse(localStorage.user_info).sale) {
        logger.logError('该机构未配置纳税人信息，不能进行该操作');
        return;
      }
      $scope.item = {
        queryOvatBillList,
        code:
          v == 1
            ? 'OVAT_BILL'
            : v == 2
            ? 'OVAT_VEHICLE_BILL'
            : v == 3
            ? 'OVAT_ROLL_BILL'
            : 'TXT',
      };
      const modalInstance = $uibModal.open({
        templateUrl: 'ovatBillModalCtrl.html',
        controller: 'ovatBillModalCtrl',
        openedClass: 'et-ovat-bill-modal mod-modal mod-modal-lg',
        backdrop: 'static',
        resolve: {
          items1() {
            return $scope.item;
          },
        },
      });
      modalInstance.result.then(
        () => {
          // console.log(222)
          queryOvatBillList();
        },
        () => {
          // console.log(111)
        }
      );
    };

    $scope.goCollectionList = function () {
      // const userInfo = JSON.parse(localStorage.getItem('user_info'))
      // httpRequest.get_getSelectKdAccountListByTenantId(userInfo.tenantId).then((res) => {
      // const kdAccountIdDicList = res.data.value
      // if (kdAccountIdDicList && kdAccountIdDicList.length) {
      $state.go('outputManage.FOManage.ovatBill.dataCollection');
      // } else {
      // logger.logError("未设置采集账套，不能进行客户端采集操作")
      // }
      // })
    };

    $scope.toDetail = function toDetail(item) {
      const url = $state.href(
        'outputManage.FOManage.ovatBill.checkBillDetail',
        {
          obj: JSON.stringify({
            billId: item.billId,
          }),
        },
        {
          reload: true,
        }
      );
      window.open(url, '_blank');
    };
    // 确定信息提交校验
    const checkSunInfo = function (item, billCodeMsg) {
      if (item.custPhone && !utils.regExpTest(item.custPhone, 'uglyPhone')) {
        logger.logError(billCodeMsg + '电话格式错误');
        return false;
      }
      if (
        item.creditType == 1 &&
        (!globalFn.checkTax(item.custCreditCode, 1) ||
          item.custCreditCode.length > 20)
      ) {
        if (!item.custCreditCode && item.invoiceType != 12) {
          logger.logError(billCodeMsg + '购方信用代码不能为空');
          return false;
        }
        if (item.custCreditCode) {
          logger.logError(
            billCodeMsg + '购方信用代码必须是6~20位大写字母或数字'
          );
          return false;
        }
      }
      if (
        !globalFn.isNullVal(item.custAddress) ||
        !globalFn.isNullVal(item.custPhone)
      ) {
        var lh = 0;
        if (globalFn.isNullVal(item.custAddress)) {
          lh += item.custPhone.toString().length;
        } else {
          lh += item.custAddress.toString().length;
        }
        if (lh < 100 && lh > 0) {
          console.log('格式正确');
        } else {
          layer.msg(billCodeMsg + '联系电话+地址总长度不能大于100位');
          return false;
        }
      }
      if (
        !globalFn.isNullVal(item.custBank) ||
        !globalFn.isNullVal(item.custBankAccount)
      ) {
        var lh = 0;
        if (globalFn.isNullVal(item.custBank)) {
          lh += item.custBankAccount.toString().length;
        } else {
          lh += item.custBank.toString().length;
        }
        if (lh < 100 && lh > 0) {
          console.log('格式正确');
        } else {
          layer.msg(billCodeMsg + '开户行+开户行账户总长度不能大于100位');
          return false;
        }
      }
      if (item.custMobile) {
        const regex = /^[0-9]{11}$/;
        const result = regex.test(item.custMobile);
        if (!result) {
          logger.logError(billCodeMsg + '手机号码格式错误');
          return false;
        }
      }
      if (item.custEmail) {
        let custEmail = item.custEmail;
        custEmail = custEmail.split(';');
        if (item.custEmail.length > 100) {
          logger.logError(billCodeMsg + '邮箱总长度不能大于100位');
          return false;
        }
        const regex = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
        for (var i = 0, len = custEmail.length; i < len; i++) {
          const result = regex.test(custEmail[i]);
          if (!result) {
            logger.logError(billCodeMsg + '邮箱格式错误');
            return false;
          }
        }
      }
      if (!globalFn.isNullVal(item.remark)) {
        var lh = item.remark.toString().length;
        if (lh < 230 && lh > 0) {
          console.log('格式正确');
        } else {
          layer.msg(billCodeMsg + '备注信息错误');
          return false;
        }
      }
      return true;
    };
    //批量操作
    $scope.batchDropdownConfig = {
      btnText: '批量操作',
      options: [
        {
          text: '批量提交',
          hasPermit: 'ovatBill_edit',
          handler() {
            $scope.billBatchCommit();
          },
        },
        {
          text: '批量删除',
          hasPermit: 'ovatBill_del',
          handler() {
            $scope.billBatchDelOrCancel(0);
          },
        },
        {
          text: '批量作废',
          hasPermit: 'ovatBill_cancel',
          handler() {
            $scope.billBatchDelOrCancel(1);
          },
        },
      ],
    };

    //销售单导入
    $scope.importDropdownConfig = {
      btnText: '销售单导入',
      options: [
        {
          text: '增值税销售单',
          hasPermit: 'ovatBill_import',
          handler() {
            $scope.open(1);
          },
        },
        {
          text: '机动车销售单',
          hasPermit: 'ovatBill_import',
          handler() {
            $scope.open(2);
          },
        },
        {
          text: '卷票销售单',
          hasPermit: 'ovatBill_import',
          handler() {
            $scope.open(3);
          },
        },
        {
          text: 'TXT导入',
          hasPermit: 'ovatBill_import',
          handler() {
            $scope.open(4);
          },
        },
        {
          text: '模板下载',
          hasPermit: 'ovatBill_import',
          handler() {
            $scope.downOvatBill();
          },
        },
      ],
    };
  }
}
ovatBillListCtrl.$inject = [
  '$scope',
  '$uibModal',
  'logger',
  'httpRequest',
  '$state',
  'sweetalert',
  'initSortService',
  'globalFn',
  'getOvatAmtService',
  'resultTipService',
  'batchHandle',
  'batchFilterService',
];
export default ovatBillListCtrl;



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/ovatBill/ovatBillListCtrl.js